export enum AssignmentFilterType {
  Me = 'Me',
  MyTeam = 'My team',
  ShowAll = 'Show all',
  Custom = 'Custom'
}
